<template>
    <div class="checkbox_input_block">
        <div class="flex flex-row items-center gap-2 action_block">
            <ActionButtons @removeFormElement="remove_form_element" />
        </div>
        <div v-if="data.label" class="mb-2">{{ data.label }}</div>
        <div :class="['input_box',{preview:preview}]">
            <input type="checkBox" />
        </div>
    </div>
</template>
<script setup>
    import ActionButtons from '../ActionButtons'
    const emit = defineEmits(['modifyFormElement','removeFormElement'])
    const props = defineProps({
        data: Object,
        index: Number,
        preview: Boolean
    })

    const remove_form_element = () => {
        emit('removeFormElement', props.index)
    }
</script>
<style lang="scss" scoped> 
    .checkbox_input_block{
        display: block;
        position: relative;        
        & > .input_box{
            input{
                pointer-events: none;
                padding: 2px 8px;
                width: 100%; border: 1px solid #ddd;
                border-radius: 5px;
            }
            &.preview > input{
                pointer-events: all;
            }
        }
    }
</style>